export default __webpack_public_path__ + "static/media/display-no-keypad.fc19a29d.png";